<script setup lang="ts">
import { ref, computed } from 'vue';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import { shouldDisplayAsJson, safeJsonParse, formatJson, truncateJson } from 'src/utils/json-utils';

const props = defineProps<{
  value: string | object;
  maxLength?: number;
}>();

const isDialogVisible = ref(false);

const isJson = computed(() => shouldDisplayAsJson(props.value));

const parsedJson = computed(() => safeJsonParse(props.value));

const formattedJson = computed(() => formatJson(props.value));

const displayValue = computed(() => {
  if (!isJson.value) return props.value;
  return truncateJson(props.value, props.maxLength || 100);
});

const showDialog = () => {
  isDialogVisible.value = true;
};
</script>

<template>
  <div class="json-display">
    <template v-if="isJson">
      <div class="flex items-center gap-2">
        <!-- <span class="text-sm font-mono text-gray-600 dark:text-gray-400">
          {{ displayValue }}
        </span> -->
        <Button
          v-if="JSON.stringify(parsedJson).length > (props.maxLength || 100)"
          type="button"
          icon="pi pi-eye"
          class="p-button-text p-button-sm"
          @click="showDialog"
          :label="`View JSON`"
        />
      </div>
    </template>
    <template v-else>
      {{ value }}
    </template>

    <Dialog
      v-model:visible="isDialogVisible"
      modal
      :header="'JSON Data'"
      :style="{ width: '50vw' }"
      maximizable
    >
      <div class="json-dialog-content">
        <pre class="json-formatted">{{ formattedJson }}</pre>
      </div>
    </Dialog>
  </div>
</template>

<style scoped>
.json-display {
  word-break: break-word;
}

.json-dialog-content {
  max-height: 60vh;
  overflow: auto;
}

.json-formatted {
  padding: 1rem;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 0.875rem;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}

</style>
